import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WebVisitorIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "WebVisitor",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M25.86 22.43H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43V19c0 1.89-1.54 3.43-3.43 3.43M5.29 4.14c-.63 0-1.14.51-1.14 1.14v13.71c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H5.29Z"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "15.57",
      cy: "9.29",
      r: "1.71"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.57 12.14a2.86 2.86 0 1 1-.001-5.719 2.86 2.86 0 0 1 .001 5.719m0-3.43c-.31 0-.57.26-.57.57s.26.57.57.57.57-.26.57-.57-.26-.57-.57-.57M12.47 17.86c-.32 0-.64-.14-.87-.4-.41-.48-.35-1.2.13-1.61a5.95 5.95 0 0 1 3.84-1.42 1.14 1.14 0 1 1 0 2.28c-.87 0-1.7.31-2.36.87-.21.18-.48.27-.74.27Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.67 17.86c-.26 0-.53-.09-.74-.27-.66-.56-1.49-.87-2.36-.87a1.14 1.14 0 1 1 0-2.28c1.41 0 2.77.5 3.84 1.42.48.41.54 1.13.13 1.61-.23.26-.55.4-.87.4ZM15.57 29.29c-.63 0-1.14-.51-1.14-1.14v-6.86a1.14 1.14 0 1 1 2.28 0v6.86c0 .63-.51 1.14-1.14 1.14"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.29 29.29H9.86a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28"
    })]
  }));
};
WebVisitorIcon.displayName = 'WebVisitorIcon';